import axios from "axiosInstance";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export default function StepperControl({ handleClick, currentStep, steps }) {
  const navigate = useNavigate();
  const submitBooking = () => {

    console.log("Submit Booking")
    const case_info = sessionStorage.getItem("caseInformation")
    const data = {
      "case_info": sessionStorage.getItem("caseInformation"),
      "parents": sessionStorage.getItem("parents"),
      "children": sessionStorage.getItem("children"),
    }
    let accessToken = sessionStorage.getItem("access_token")
    if (accessToken != null) {
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'case/',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Token " + accessToken
        },
        data: data
      };

      axios.request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          if (response.status == 200) {
            toast.success("Case created successfully")
            setTimeout(() => {
              navigate("/platform/cases/list")
            }, 3000);

          }
        })
        .catch((error) => {
          console.log(error);
        });


    }
  }
  return (
    <div className="mt-2 flex flex-col justify-between px-3 pt-2 md:flex-row md:px-8">
      {currentStep === steps.length - 3 ? (
        <div />
      ) : (
        <button
          onClick={() => handleClick()}
          className={`mb-3 cursor-pointer rounded-xl bg-lightPrimary px-16 py-2 font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mb-0`}
        >
          Prev
        </button>
      )}

      <button
        onClick={currentStep !== steps.length ? () => handleClick("next") : () => submitBooking()}
        className="cursor-pointer rounded-xl bg-blue-950 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
      >
        {currentStep !== steps.length ? "Next" : "Submit"}
      </button>
      <ToastContainer />
    </div>
  );
}
